import { ChevronDown, ChevronUp, Edit3, Trash2 } from 'lucide-react';
import Button from '../../../../components/Button';
import type { QuestTemplateFieldToCollect } from '../../services/questTypes';

interface FieldToCollectDisplayProps {
    isFirst: boolean;
    isLast: boolean;
    field: QuestTemplateFieldToCollect;
    isEditing: boolean;
    onMoveUp: () => void;
    onMoveDown: () => void;
    onEdit: () => void;
    onDelete: () => void;
}

export const FieldToCollectDisplay = ({ isFirst, isLast, field, isEditing, onMoveUp, onMoveDown, onEdit, onDelete }: FieldToCollectDisplayProps) => {
    return (

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 sm:gap-4">
                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        #{field.order}
                    </span>
                    <div className="min-w-0 break-words">
                        <div className="font-medium text-gray-900 mb-2">{field.key}</div>
                        <div className="text-sm text-gray-800 mb-2"><b>Description:</b> {field.description}</div>
                        <div className="text-sm text-gray-600"><b>AI Guidance:</b> {field.aiGuidance}</div>
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-1 self-end sm:self-auto">
                <Button
                    variant="ghost"
                    size="sm"
                    icon={<ChevronUp className="w-4 h-4" />}
                    onClick={onMoveUp}
                    disabled={isFirst || isEditing}
                    title="Move up"
                />
                <Button
                    variant="ghost"
                    size="sm"
                    icon={<ChevronDown className="w-4 h-4" />}
                    onClick={onMoveDown}
                    disabled={isLast || isEditing}
                    title="Move down"
                />
                <Button
                    variant="ghost"
                    size="sm"
                    icon={<Edit3 className="w-4 h-4" />}
                    onClick={onEdit}
                    disabled={isEditing}
                    title="Edit"
                />
                <Button
                    variant="ghost"
                    size="sm"
                    icon={<Trash2 className="w-4 h-4" />}
                    onClick={onDelete}
                    disabled={isEditing}
                    title="Delete"
                    className="text-red-600 hover:text-red-700 hover:bg-red-50"
                />
            </div>
        </div>
    );
};